<template>
  <AppAlert type="info" icon="mdi:medical-bag">
    {{ $tt('medical_insurance_included') }}
  </AppAlert>
</template>